"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgLateDeparture = function SvgLateDeparture(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M6.605 6.75c.247.625.98.92 1.637.66.331-.13.58-.377.713-.67m4.555.01c-.246.625-.98.92-1.636.66a1.31 1.31 0 0 1-.714-.67m3.93-4.147c0 1.045-1.127 1.9-2.517 1.9h-.752c-.85 0-1.687 1.326-1.821 1.326-.134 0-.972-1.326-1.821-1.326h-.752c-1.39 0-2.518-.855-2.518-1.9",
    stroke: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.264 4.985a4.734 4.734 0 1 1-8.527 0",
    stroke: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.829 8.594c0 .635-.829 1.866-.829 1.866s-.829-1.23-.829-1.866c0-.636.371-.645.829-.645.458 0 .829.009.829.645Z",
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5.447 8.243-.614 8.587c.386 0 .901-.004 1.462-.063m4.038-3.79c-.05 1.995-1.13 2.957-2.373 3.421m-1.665.369.31-4.02m-.31 4.02a6.854 6.854 0 0 0 1.665-.369m0 0 .178-2.261",
    stroke: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.734 7.115v5.4c0 2.665-2.09 4.826-4.668 4.826a4.546 4.546 0 0 1-2.724-.906m3.929.905v1.034M9.799 17.34v1.034",
    stroke: "#4D4D4D"
  }));
};
var Memo = /*#__PURE__*/(0, _react.memo)(SvgLateDeparture);
var _default = exports["default"] = Memo;